import React from 'react';
import Image from 'next/image';
import { ClonePlusDescriptionProps } from '@/components/chat/types';

const ClonePlusDescription: React.FC<ClonePlusDescriptionProps> = ({ cloneExtra }) => (
  <div className="tw-h-[calc(100svh-20px)] tw-overflow-y-auto tw-overflow-x-hidden tw-px-[5px]">
    <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-1 tw-flex">
      <div className="tw-text-gray-700 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
        {cloneExtra?.data?.name}
      </div>
      {cloneExtra?.data?.profession && (
        <div className="tw-self-stretch tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
          {cloneExtra?.data?.profession}
        </div>
      )}
    </div>

    {cloneExtra?.externalLinks?.length > 0 && (
      <React.Fragment>
        <div className="tw-self-stretch tw-h-[0px] tw-border tw-border-gray-300"></div>
        <div className="tw-flex-col tw-justify-center tw-items-start tw-gap-3 tw-flex tw-py-3">
          <div className="tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">
            All My Links
          </div>
          <div className="tw-justify-start tw-items-start tw-gap-3 tw-inline-flex tw-flex-wrap">
            {cloneExtra?.externalLinks.map((link, index) => (
              <a
                key={index}
                href={link.link}
                target="_blank"
                rel="noopener noreferrer"
                className="tw-p-2 tw-bg-gray-100 tw-shrink-0 tw-rounded-[99px] tw-justify-start tw-items-center tw-gap-2.5 tw-flex"
              >
                <Image
                  priority
                  quality={100}
                  width={20}
                  height={20}
                  src={link.logo}
                  alt="Social media link"
                  title="Social media link"
                />
              </a>
            ))}
          </div>
        </div>
      </React.Fragment>
    )}

    <div className="tw-self-stretch tw-h-[0px] tw-border tw-border-gray-300"></div>
    <div className="tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
      <div className="tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">Bio</div>
      <div className="tw-self-stretch tw-h-full tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal tw-overflow-y-auto">
        {cloneExtra?.data?.bio.split(/\n/g).map((section, idx) => (
          <React.Fragment key={idx}>
            <p>{section}</p>
            <br />
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
);

export default ClonePlusDescription;
